<template>
    <v-layout>
        <v-footer class="mt-4">
            <div>* YEU: Yıllık Eğitim Ücreti</div>
        </v-footer>
    </v-layout>
</template>

<script>
    export default {
        name: "AppFooter"
    }
</script>